import React from 'react';
import * as PropTypes from 'prop-types';
import { Button, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faTimes,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

const MenuTitle = ({ back, close, children, extraButtons }) => (
  <div className="menu-title">
    {!back ? null : (
      <div className="menu-title-button">
        <ButtonGroup size="sm">
          <Button onClick={back} title="Back" variant="secondary">
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
          {extraButtons}
        </ButtonGroup>
      </div>
    )}
    <h2 className="menu-title-text">{children}</h2>
    <div className="menu-title-button">
      <Button onClick={close} title="Close" size="sm" variant="secondary">
        <FontAwesomeIcon icon={faTimes} />
      </Button>
    </div>
  </div>
);

MenuTitle.propTypes = {
  back: PropTypes.func,
  close: PropTypes.func,
};

export default MenuTitle;
